import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { getJBPMarketLeasingCrud } from './helpers/getJBPMarketLeasingCrud'

export interface IFetchPartnerMarketLeasingParams {
  partnerId: string
  programType: ProgramTypes
  fYear: number
}

export const fetchPartnerMarketLeasing = async ({
  partnerId,
  programType,
  fYear,
}: IFetchPartnerMarketLeasingParams) => {
  const marketLeasingCrud = getJBPMarketLeasingCrud({
    partnerId,
    programType,
    fYear,
  })

  const data = await marketLeasingCrud.fetch({ force: true })
  if (data.items.length === 0) {
    throw Error('No partner market leasing information')
  }

  return data.items[0]
}
